// extracted by mini-css-extract-plugin
export default {"header":"CopyModal_header__z3QdI","select":"CopyModal_select__07NYR"};